import React, { FC, useState } from "react";
import { Button, Input } from "@shared/components";

import { CHAT_MAX_TITLE_LENGTH, CHAT_MIN_TITLE_LENGTH } from "../../constants";

import "./RenameChatModal.scss";

interface RenameChatModalProps {
  initialTitle: string;
  onRename: (title: string) => void;
  onClose: () => void;
  onSuccess: () => void;
}

const RenameChatModal: FC<RenameChatModalProps> = ({ initialTitle, onRename, onClose, onSuccess }) => {
  const [value, setValue] = useState(initialTitle);

  const trimmedValue = value.trim();
  const isEmpty = trimmedValue.length === 0;
  const isTooShort = !isEmpty && trimmedValue.length < CHAT_MIN_TITLE_LENGTH;
  const hasChanges = trimmedValue !== initialTitle.trim();
  const isRenameDisabled = !hasChanges || isEmpty || isTooShort;

  const handleRename = () => {
    if (isRenameDisabled) return;
    onRename(trimmedValue);
    onSuccess();
  };

  return (
    <div className="rename-chat-modal">
      <div className="modal-heading">Rename chat</div>
      <Input
        value={value}
        maxLength={CHAT_MAX_TITLE_LENGTH}
        autoFocus
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
      />
      <div className="rename-chat-modal-footer">
        {isEmpty && <span className="rename-chat-modal-error">Title cannot be empty</span>}
        {!isEmpty && isTooShort && (
          <span className="rename-chat-modal-error">Title must be at least {CHAT_MIN_TITLE_LENGTH} characters</span>
        )}
        <span className="rename-chat-modal-counter">
          {value.length}/{CHAT_MAX_TITLE_LENGTH}
        </span>
      </div>
      <div className="modal-actions">
        <Button appearance="subtle" className="subtle auto-width" onClick={onClose}>
          Cancel
        </Button>
        <Button type="submit" className="accent padding margin-left" disabled={isRenameDisabled} onClick={handleRename}>
          Rename
        </Button>
      </div>
    </div>
  );
};

export default RenameChatModal;
